import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
// import Home from '../views/Home.vue';
import Profile from '../views/Profile.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    children: [
      {
        path: '',
        name: 'Profile.Welcome',
        // route level code-splitting
        // this generates a separate chunk (Profile.Welcome.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "Profile.Welcome" */ '../views/Welcome.vue'),
      },
      {
        path: 'onboarding',
        name: 'Profile.Onboarding',
        // route level code-splitting
        // this generates a separate chunk (Profile.Onboarding.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "Profile.Onboarding" */ '../views/OnBoarding.vue'),
      },
      {
        path: 'function-role',
        name: 'Profile.FunctionRole',
        // route level code-splitting
        // this generates a separate chunk (Profile.FunctionRole.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "Profile.FunctionRole" */ '../views/FunctionRole.vue'),
      },
      {
        path: 'industry',
        name: 'Profile.Industry',
        // route level code-splitting
        // this generates a separate chunk (Profile.Industry.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "Profile.Industry" */ '../views/Industry.vue'),
      },
      {
        path: 'domain',
        name: 'Profile.Domain',
        // route level code-splitting
        // this generates a separate chunk (Profile.Domain.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "Profile.Domain" */ '../views/Domain.vue'),
      },
      {
        path: 'digital',
        name: 'Profile.Digital',
        // route level code-splitting
        // this generates a separate chunk (Profile.Digital.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "Profile.Digital" */ '../views/Digital.vue'),
      },
      {
        path: 'professional',
        name: 'Profile.Professional',
        // route level code-splitting
        // this generates a separate chunk (Profile.Professional.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "Profile.Professional" */ '../views/Professional.vue'),
      },
      {
        path: 'summary',
        name: 'Profile.Summary',
        // route level code-splitting
        // this generates a separate chunk (Profile.Summary.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "Profile.Summary" */ '../views/Summary.vue'),
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
});

export default router;
